import { loc } from "../../../core/utils"

export const requiredMessage = () => loc("Required")

var lowerCase = /[a-z]/g
var upperCase = /[A-Z]/g
var numbers = /[0-9]/g

const validate = (values) => {
  const { oldPassword, newPassword, verifyNewPassword } = values
  const lowerCaseMessage = "one_lower_case_required"
  const upperCaseMessage = "one_upper_case_required"
  const numberMessage = "one_number_required"
  const moreThanHeight = "more_than_height_length"
  const differentPassword = "different_password"
  const confirmationPassword = "confirmation_password_matches_new_password"

  const errors = {
    oldPassword: [],
    newPassword: [],
    verifyNewPassword: []
  }

  const areFieldsEmpty = !oldPassword && !newPassword && !verifyNewPassword

  if (!oldPassword) errors.oldPassword.push("required")

  if (!newPassword) errors.newPassword.push("required")

  if (!verifyNewPassword) errors.newPassword.push("required")

  if (areFieldsEmpty) return errors

  if (newPassword === oldPassword || verifyNewPassword === oldPassword) errors.newPassword.push(differentPassword)

  if (!!newPassword && !!verifyNewPassword && newPassword !== verifyNewPassword)
    errors.newPassword.push(confirmationPassword)

  if (!newPassword?.match(lowerCase)) errors.newPassword.push(lowerCaseMessage)

  if (!newPassword?.match(upperCase)) errors.newPassword.push(upperCaseMessage)

  if (!newPassword?.match(numbers)) errors.newPassword.push(numberMessage)

  if (newPassword?.length < 8) errors.newPassword.push(moreThanHeight)

  return errors
}

export default validate
